export default __webpack_public_path__ + "static/artifakt-element-bold-48cbdc2a3040dbc7ebbcab981eac32c8.woff2";